var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchenette(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.75 4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.165 11.754c.391-1.032 1.608-1.868 2.706-1.868h10.052c1.104 0 2.316.838 2.706 1.868l1.165 3.074H0l1.165-3.074z",
    stroke: "#666",
    fill: "#666",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "#FFF",
    strokeLinecap: "round",
    cx: 9.391,
    cy: 12.357,
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.437 9.899V8.413M12.357 9.899V8.413"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.977 4.284h14.03l-.668 2.07c-.336 1.04-1.49 1.884-2.581 1.884H5.226c-1.09 0-2.244-.839-2.581-1.884l-.668-2.07zM12.4 4.246L17.3.494",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    d: "M16.826 5.968h-.93M2.348 5.968H1.026"
  })))));
}
export default SvgKitchenette;